import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    async function verify() {
      const invoiceId = searchParams.get('invoice');
      const orderId = searchParams.get('token'); // PayPal passes order ID as 'token'
      const payerId = searchParams.get('PayerID');

      if (!orderId || !payerId || !invoiceId) {
        setStatus('error');
        return;
      }

      try {
        const res = await fetch(
          'https://europe-west2-le-douit-horticulture.cloudfunctions.net/capturePaypalOrder',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ orderId, invoiceId }),
          }
        );
        const { captured } = await res.json();
        setStatus(captured ? 'success' : 'error');
      } catch {
        setStatus('error');
      }
    }
    verify();
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: 24, background: 'var(--bg)' }}>
      <div style={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>

        {status === 'checking' && (
          <>
            <div className="spinner" />
            <p style={{ color: 'var(--text-muted)', marginTop: 16 }}>Confirming your payment…</p>
          </>
        )}

        {status === 'success' && (
          <div className="card">
            <div style={{ fontSize: 56, marginBottom: 16 }}>✅</div>
            <h2 style={{ color: 'var(--green-dark)', marginBottom: 12 }}>Payment received!</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 24, lineHeight: 1.6 }}>
              Thank you — your PayPal payment has been processed successfully.
              You'll receive a confirmation email and Dean will be in touch shortly.
            </p>
            <button className="btn-primary" onClick={() => navigate('/dashboard')}>
              Back to my jobs
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="card">
            <div style={{ fontSize: 56, marginBottom: 16 }}>⚠️</div>
            <h2 style={{ marginBottom: 12 }}>Something went wrong</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>
              We couldn't confirm your payment status. If money has left your account,
              please contact Dean directly — your payment will be confirmed manually.
            </p>
            <button className="btn-primary" onClick={() => navigate('/invoices')} style={{ marginBottom: 10 }}>
              Back to invoices
            </button>
          </div>
        )}

      </div>
    </div>
  );
}
